import adviceLogo from '../../assets/advice.png';
import { HeaderStyles } from "./styles";
import { Navbar, Container, Row } from 'react-bootstrap';
import {ImClock} from "react-icons/im";

export function Header() {
    return (
      <HeaderStyles>
        <header>
          <Container fluid className="col-md-12" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <Navbar bg="header">
                <Row className="col-12">
                  <div className="horario col-12">
                    <ul>
                      <li className="text-nowrap">
                        <ImClock className="clock"/><span>Seg - Sex: 8:30 - 18:00</span>
                      </li>
                    </ul>
                  </div>
                </Row>
            </Navbar>       
          </Container>
              <div className="mt-2" style={{ paddingLeft: 0, paddingRight: 0, }}>
                <a href="https://www.advice.inf.br/" target="_blank" rel="noopener noreferrer">
                    <img className="float-start col-3 col-md-1 col-sm-3 mb-4" src={adviceLogo} alt="Advice" />
                </a>
              </div>       
        </header>
      </HeaderStyles>
    );
  }